import { ReactNode } from 'react';
import classnames from 'classnames';
import isNull from 'lodash/isNull';

import style from './FieldTitle.module.scss';
import '@components/Print/Print_.scss';
import '@components/mixins/commonStyles.scss';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

export interface FieldTitleParams {
    title: ReactNode;
    isValid?: Nullable<boolean>;
    theme?: FieldTitleTheme;
    modificators?: FieldTitleModificator[];
    disabled?: boolean;
    hideOnPrint?: boolean;
    clickableTitle?: boolean;
    onClick?(): void;
}

export enum FieldTitleTheme {
    // @ts-ignore
    Bold = style.bold,
    // @ts-ignore
    BigBold = style.bigBold,
    // @ts-ignore
    WithoutPadding = style.withoutPadding,
    // @ts-ignore
    FoldingContent = style.foldingContent,
    // @ts-ignore
    WithFlex = style.with_flex,
    // @ts-ignore
    Grey = style.grey,
}

export enum FieldTitleModificator {
    // @ts-ignore
    Heading = style.heading,
    // @ts-ignore
    WithCaption = style.withCaption,
    // @ts-ignore
    WithPadding = style.withPadding,
    // @ts-ignore
    WithoutPadding = style.withoutPadding,
    // @ts-ignore
    InheritColor = style.inheritColor,
    // @ts-ignore
    ExtraHeight = style.extraHeight,
}

interface Props extends FieldTitleParams {}

export function FieldTitle({
    title,
    clickableTitle,
    disabled,
    theme,
    modificators = [],
    isValid = null,
    hideOnPrint = false,
    onClick,
}: Props) {
    return (
        <div
            className={classnames([
                style.root,
                theme,
                'font_label',
                hideOnPrint && 'hide_on_print',
                disabled && style.disabled,
                !isNull(isValid) && (isValid ? style.valid : style.notValid),
                !!onClick && clickableTitle && style.clickable,
                ...modificators,
                'printElement_marginBottom_0',
                'printElement_withoutPadding',
                'print_inheritFont',
                'print_h2_title',
            ])}
        >
            {title}
        </div>
    );
}
